import React from 'react'
import Responsive, { MediaQueryProps } from 'react-responsive'
import { useMediaQuery } from '@material-ui/core'
import { theme } from '../../theme'

function Desktop(props: MediaQueryProps) {
  return <Responsive {...props} minWidth={theme.breakpoints.tablet} />
}

export function useIsDesktop() {
  const matches = useMediaQuery(`(min-width: ${theme.breakpoints.tablet})`)

  return matches
}

export default Desktop
